import { type Item } from '@cheqroom/api';
import { Archive, Dot } from '@cheqroom/icons';

export const getStatusIcon = (item: Pick<Item, 'status'>) => {
	switch (item.status) {
		case 'expired':
			return Archive;
		default:
			return Dot;
	}
};
